import React from 'react'

const Home = () => {
    return (
        <>
            <main>
                <section className="relative overflow-hidden hero-gradient pt-16 pb-20 lg:pt-24 lg:pb-32">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                            <div className="flex flex-col space-y-8 max-w-2xl">
                                <div className="space-y-4">
                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-accent-light text-primary tracking-wide uppercase">
                                        Independent tutors you can trust.
                                    </span>
                                    <h1 className="text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.1]">
                                        Trusted, verified tutors for families{" "}
                                        across the <span className="text-primary">United Arab Emirates.</span>
                                    </h1>
                                    <p className="text-lg lg:text-xl text-slate-600 leading-relaxed max-w-xl">
                                        Choose from a carefully vetted selection of independent tutors to
                                        suit your child’s unique needs and learning journey.
                                    </p>
                                </div>
                            </div>
                            <div className="relative">
                                <div className="relative z-10 overflow-hidden rounded-3xl shadow-2xl">
                                    <img
                                        alt="Realistic photograph of a focused student interacting with a tutor online"
                                        className="w-full h-auto aspect-[4/3] lg:aspect-[5/6] object-cover"
                                        src={process.env.PUBLIC_URL + "/assets/home.png"}
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
                                </div>
                                <div className="absolute -top-10 -right-10 size-64 bg-primary/5 rounded-full blur-3xl -z-10" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="py-24 bg-white">
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
                            <h2 className="text-3xl lg:text-4xl font-extrabold text-slate-900 tracking-tight">
                                The smarter way to learn
                            </h2>
                            <p className="text-lg text-slate-600">
                                Tutor Match AE is a thoughtfully designed platform built around choice, trust, and quality.
                            </p>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                            <div className="flex flex-col gap-6 group">
                                <div className="size-14 rounded-2xl bg-accent-light flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                                    <span className="material-symbols-outlined text-3xl">verified</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-slate-900 mb-3">
                                        Vetted Professionals
                                    </h3>
                                    <p className="text-slate-600 leading-relaxed">
                                        Each independent tutor is vetted through identity and permit checks, supporting a safe and trusted learning experience.
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-6 group">
                                <div className="size-14 rounded-2xl bg-accent-light flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                                    <span className="material-symbols-outlined text-3xl">
                                        psychology
                                    </span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-slate-900 mb-3">
                                        Tailored Learning
                                    </h3>
                                    <p className="text-slate-600 leading-relaxed">
                                        Choose from a range of tutors who tailor learning to support each learner’s pace, strengths, and individual goals.
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-6 group">
                                <div className="size-14 rounded-2xl bg-accent-light flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                                    <span className="material-symbols-outlined text-3xl">
                                        event_available
                                    </span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-slate-900 mb-3">
                                        Total Flexibility
                                    </h3>
                                    <p className="text-slate-600 leading-relaxed">
                                        Book sessions that fit around your schedule, with the flexibility to manage bookings and rescheduling through a simple, easy-to-use dashboard.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="pb-24 px-6 lg:px-8">
                    <div className="mx-auto max-w-7xl rounded-3xl bg-primary px-8 py-16 lg:py-24 text-center text-white relative overflow-hidden">
                        <div className="relative z-10 max-w-3xl mx-auto space-y-8">
                            <h2 className="text-3xl lg:text-5xl font-extrabold tracking-tight">
                                Ready to start your journey?
                            </h2>
                            <p className="text-lg lg:text-xl text-white/80">
                                Download the app and join Tutor Match AE today.
                            </p>
                            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
                                {/* Google Play */}
                                <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block"
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/Google_Play_Store_badge_EN.svg"}
                                        alt="Get it on Google Play"
                                        className="h-14"
                                    />
                                </a>
                                {/* App Store */}
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/download-on-the-app-store.svg"}
                                        alt="Download on the App Store"
                                        className="h-14"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="absolute inset-0 opacity-10 pointer-events-none">
                            <svg className="h-full w-full" fill="none" viewBox="0 0 400 400">
                                <defs>
                                    <pattern
                                        height={40}
                                        id="dots"
                                        patternUnits="userSpaceOnUse"
                                        width={40}
                                        x={0}
                                        y={0}
                                    >
                                        <circle cx={2} cy={2} fill="currentColor" r={1} />
                                    </pattern>
                                </defs>
                                <rect fill="url(#dots)" height="100%" width="100%" />
                            </svg>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default Home;